import { InjectionToken } from '@angular/core';
import { ILogLayer } from 'loglayer';

export const LOG_LAYER = new InjectionToken<ILogLayer>('LOG_LAYER');
